export default __webpack_public_path__ + "static/media/no-results.8c9441c7.svg";